import { createFileRoute } from '@tanstack/react-router'

import { requirePermissions } from '#/shared/routing/require-permissions.ts'

// No component: a route without one renders its `<Outlet />`, and each guarantee screen now owns
// its own View frame.
export const Route = createFileRoute('/(customer)/_shell/product-guarantees')({
  beforeLoad: ({ context }) => requirePermissions(context, ['contract.read']),
})
